import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "folder-filled-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.25 6.00012C2.25 4.48091 3.48079 3.25012 5 3.25012H9.471C10.0508 3.25012 10.5915 3.53739 10.9168 4.01483L12.3221 6.08023C12.3683 6.14834 12.4462 6.19012 12.529 6.19012H19C20.5195 6.19012 21.75 7.42215 21.75 8.94012V18.0001C21.75 19.5193 20.5192 20.7501 19 20.7501H5C3.48079 20.7501 2.25 19.5193 2.25 18.0001V6.00012Z" }, null, -1)
  ])))
}
export default { render: render }